<template>
  <v-card>
    <v-card-title class="text-h6">Confirmación Administrador</v-card-title>
    <v-card-text>
      <v-text-field v-model="usuario" label="Usuario (admin)" outlined dense></v-text-field>
      <v-text-field v-model="password" label="Contraseña" type="password" outlined dense></v-text-field>
      <v-textarea v-model="motivo" label="Motivo (obligatorio)" rows="3" outlined dense></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancelar')">Cancelar</v-btn>
      <v-btn color="red" dark @click="confirmar" :disabled="!usuario || !password || !motivo">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DialogoConfirmAdmin",
  data: () => ({ usuario: '', password: '', motivo: '' }),
  methods: {
    confirmar() { this.$emit('confirmar', { usuario: this.usuario, password: this.password, motivo: this.motivo }); }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dialogos/DialogoConfirmAdmin.vue